import en from "./english";
import du from "./dutch";
export const LINKS = {
  en,
  du,
};
